<template>
  <div>
    <InAppBrowserWarning />
    <router-view @toggleLoading="toggleLoading" />
    <Loading v-show="is_loading" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from 'vue-facing-decorator';
import Loading from './components/Loading.vue';
import InAppBrowserWarning from './components/InAppBrowserWarning.vue';

@Component({
  components: {
    Loading,
    InAppBrowserWarning,
  },
  emits: ['toggleLoading'],
})
class App extends Vue {
  // ローディング表示
  is_loading = true;

  // Loadingの表示，非表示
  toggleLoading(params: { is_loading: boolean; time: number }): void {
    if (params.is_loading) {
      this.is_loading = true;
    } else if (params.time != 0) {
      setTimeout(() => {
        this.is_loading = false;
      }, params.time * 1000);
    } else {
      this.is_loading = false;
    }
  }
}
export default toNative(App);
</script>

<style lang="scss">
@import 'assets/scss/style';
</style>
